{
  "eyebrow": "Faturalama ve ödeme",
  "title": "Neredeyse bitti.",
  "sub": "30 günlük denemenizi başlatmak için güvenli ödemeye geçin. Bugün ücretlendirilmeyeceksiniz.",
  "summary": {
    "company": "Şirket",
    "plan": "Plan",
    "cycle": "Faturalama döngüsü",
    "users": "Kullanıcılar",
    "vtt": "Vehicle Track & Trace",
    "vehicles": "Araçlar",
    "total": "Tahmini toplam / ay",
    "vttOn": "Dahil"
  },
  "secureNote": "Stripe ile güvenli ödeme · 30 gün ücretsiz deneme · İstediğiniz zaman iptal",
  "continue": "Stripe'a devam et",
  "submitting": "Stripe açılıyor…",
  "canceled": {
    "title": "Ödeme iptal edildi",
    "sub": "Herhangi bir ücret alınmadı. Tekrar deneyin veya yardım için bize ulaşın.",
    "retry": "Tekrar dene"
  },
  "promo": {
    "toggle": "Promosyon kodunuz var mı?",
    "placeholder": "Promosyon kodu",
    "apply": "Uygula",
    "chip": "%{{percent}} indirim",
    "remove": "Promosyon kodunu kaldır",
    "errorGeneric": "Kod doğrulanamadı. Lütfen tekrar deneyin."
  },
  "errors": {
    "generic": "Ödeme başlatılamadı. Lütfen tekrar deneyin."
  },
  "totalUnavailable": "Fiyat kataloğu kullanılamıyor. En güncel fiyatları yüklemek için tekrar deneyin."
}
